import { inject } from '@angular/core';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate | null> = (
  component: CanComponentDeactivate | null
) => {
  if (component?.canDeactivate && !component.canDeactivate()) {
    const translateService = inject(TranslateService);
    return confirm(translateService.instant('common.leaveWithoutSaveMessage'));
  }
  return true;
};

export type CanDeactivateType = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

export interface CanComponentDeactivate {
  canDeactivate(): CanDeactivateType;
}
